module.exports = __webpack_public_path__ + "img/logo_home_b@44x.5957c77a.png";